import { createContext, useContext } from 'react';

import { TDocumentRequirement } from './helpers/stepCompletion.helper';

export type StepValue = {
  index: number;
  requirement: TDocumentRequirement;
  title: string | undefined;
  errorMessage?: string;
  isActive: boolean;
  isComplete: boolean;
  isError: boolean;
  isLastStep: boolean;
  showDirectUpload: boolean;
  onContinue: () => void;
  onRequestUpload: () => void;
};

const StepContext = createContext<StepValue | null>(null);

export const StepProvider = StepContext.Provider;

export const useStep = (): StepValue => {
  const value = useContext(StepContext);
  if (!value) {
    throw new Error('useStep must be used within <StepProvider>');
  }
  return value;
};
